import * as actions from './action';

const init = {
  activeStep: 1,
  streamConfig: {
    actions: [{ config: {} }],
    name: null,
  },
};

export default (state = init, action) => {
  const newState = { ...state };

  switch (action.type) {
    case actions.AISLE_LAUNCH_SET_STEP:
      newState.activeStep = action.payload;
      break;

    case actions.AISLE_STREAM_NAME:
      newState.streamConfig.name = action.payload;
      break;

    case actions.AISLE_STREAM_ADD_ACTIONS:
      newState.streamConfig.actions = [...newState.streamConfig.actions, action.payload];
      break;

    case actions.AISLE_PUSH_CONFIG:
      newState.config = { ...state.config };
      if (typeof newState.config[action.name] === 'object' && newState.config[action.name] !== null) {
        newState.config[action.name] = [...newState.config[action.name]];
        newState.config[action.name].push(action.payload);
      } else {
        newState.config[action.name] = action.payload;
      }
      break;

    case actions.AISLE_REPLACE_CONFIG:
      newState.config = { ...state.config };

      if (typeof newState.config[action.name] === 'object') {
        newState.config[action.name] = [action.payload];
      } else {
        newState.config[action.name] = action.payload;
      }
      break;

    default:
  }
  return newState;
};
